// extracted by mini-css-extract-plugin
module.exports = {"Button":"Scramble_Button__3sjXv"};